import styled from 'styled-components';
import { Col } from 'antd';

export const SubtitleCol = styled(Col)`
	display: flex;
	justify-content: space-between;
`;
